<a
  *ngIf="link?.type === cardLinkType.EXTERNAL || link?.deepLinkBase === deepLinkBase.ExternalLink"
  [href]="link?.uri"
  [ngClass]="{
    'icon-link': showCompactView && requestType,
    'button button-pill button-reverse button-cta': requestType,
    'cta-non-card': !requestType
  }"
  [title]="link?.altText || callToAction || ''"
  target="_blank"
  (click)="handleCardCTAClick($event)">
  <ng-container *ngTemplateOutlet="ctaContent"></ng-container>
</a>

<a
  *ngIf="link?.type === cardLinkType.INTERNAL"
  [href]="navigationOptions?.route"
  [routerLink]="[navigationOptions?.route]"
  [queryParams]="navigationOptions?.queryParams"
  [ngClass]="{
    'icon-link': showCompactView && requestType,
    'button button-pill button-reverse button-cta': requestType,
    'cta-non-card': !requestType
  }"
  [title]="link?.altText || callToAction || ''"
  (click)="handleCardCTAClick($event)">
  <ng-container *ngTemplateOutlet="ctaContent"></ng-container>
</a>

<button
  *ngIf="link?.type === cardLinkType.ACTION"
  [ngClass]="{
    'icon-link': showCompactView && requestType,
    'button button-pill button-reverse button-cta button-action': requestType,
    'cta-non-card': !requestType
  }"
  [title]="link?.altText || callToAction || ''">
  <ng-container *ngTemplateOutlet="ctaContent"></ng-container>
</button>

<ng-template #ctaContent>
  <svg-icon
    *ngIf="showCompactView && requestType && isQuestCard"
    src="/assets/icons/icons-nav-quest-flag.svg"></svg-icon>
  <svg-icon *ngIf="showCompactView && requestType && !isQuestCard" src="/assets/icons/link.svg"></svg-icon>
  <ng-container *ngIf="!showCompactView && requestType">
    {{ callToAction }}
  </ng-container>
  <ng-content *ngIf="!requestType"></ng-content>
</ng-template>
